import React from 'react'
import dynamic from 'next/dynamic'
import cn from 'classnames'
import { QuizOnlyOnce } from './components/QuizOnlyOnce'
import styles from './HeroQuiz.module.scss'

const HomepageCarousel = dynamic(
  () =>
    import('components/HomepageCarousel').then((mod) => mod.HomepageCarousel),
  { ssr: true },
)

export const HeroQuiz = () => (
  <div className='container'>
    <div className='row no-gutters'>
      <div className='col-12 col-md-7 col-lg-6'>
        <QuizOnlyOnce />
      </div>
      <div className='d-none d-md-block d-lg-none col-md-1' />
      <div className={cn('col-12 col-md-4 col-lg-6', styles.carousel)}>
        <HomepageCarousel />
      </div>
    </div>
  </div>
)
